import { DataDailyToday } from 'Consts/types';

import * as api from 'Api/endpoints';

import type { RootState, Action } from 'State/store';
import { createStandardSlice } from 'State/utils';

const slice = createStandardSlice<Record<string, DataDailyToday>>(
  'personDailyDataUsage'
);

const fetchData = (personId: string): Action => {
  return async (dispatch, getState) => {
    const { activeLocation } = getState().locations;
    const customerId = activeLocation?.customerId;
    const { data: token } = getState().locations.activeLocation
      ?.accessedAsCoAdminLocation
      ? getState().auth.coAdminData
      : getState().auth.data;
    const cloud = getState().auth.cloud;

    if (!customerId || !token || !activeLocation?.id) {
      return;
    }

    dispatch(actions.isLoading(true));

    const { data, error } = await api.getPersonDailyDataUsageCategories({
      personId,
      customerId,
      locationId: activeLocation.id,
      token,
      cloud,
    });

    if (error || !data) {
      dispatch(actions.error(error?.message || 'Error fetching data usage'));

      return;
    }
    dispatch(actions.update({ [personId]: data?.dailyToday }));
  };
};

export const selectors = (state: RootState) => state.dataUsage.person.daily;

export const actions = {
  ...slice.actions,
  fetchData,
};

export default slice.reducer;
